import { useEffect } from 'react';

import { IAnalyticsMetadataFields } from '../../types/contentful';

import analytics from '../utils/analytics';
import { getCookie } from '../utils/cookies';
import { getDeviceType } from '../utils/detectDevice';
import { setRumUser } from '../utils/datadogRum';
import { getAnonymousId } from '../utils/getAnonymousId';

export function usePageAnalytics(analyticsMetadata?: IAnalyticsMetadataFields) {
  useEffect(() => {
    const userId = getAnonymousId();

    // Update RUM context with userId
    setRumUser({ id: userId });

    // Ensure Segment anonId is in sync with userId
    analytics.setAnonymousId(userId);

    // Trigger Segment Loaded a Page event
    analytics.page(
      analyticsMetadata?.category || '',
      analyticsMetadata?.name || '',
      {
        anonymousId: userId,
        deviceType: getDeviceType(),
        returningUser: getCookie('gl_is_returning_user'),
        registeredUser: getCookie('gl_is_registered_user')
      }
    );

    // Mixpanel is loaded by segment in device mode, meaning their anonymous ids diverge when using anonymous id on backend.
    // Doing an alias here should fix that to stitch mixpanel's anonid and segment's
    (function aliasMixpanel() {
      if (window.mixpanel && typeof window.mixpanel.alias === 'function') {
        window.mixpanel.alias(analytics.anonymousId as string);
      } else {
        setTimeout(aliasMixpanel, 2000); // if mixpanel doesnt exist yet, try again in 2 seconds
      }
    })();
  }, []);
}
